import { render, staticRenderFns } from "./modalpolicies.vue?vue&type=template&id=1163810e"
import script from "./modalpolicies.vue?vue&type=script&lang=js"
export * from "./modalpolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports